import { LOCAL_STORAGE_KEY, FAVORITE_LIST } from '../global/enums'

class LocalStorageService {

  constructor({ jwt }){
    this.jwt = jwt
  }

  hasToken = () => {
    try {
      const item = localStorage.getItem(LOCAL_STORAGE_KEY)
      if (item) {
        return true
      } else {
        return false
      }
    } catch (err) {
      return false
    }
  }

  setLocalStorageToken(token) {
     localStorage.removeItem(LOCAL_STORAGE_KEY)
     localStorage.setItem(LOCAL_STORAGE_KEY, token)
  }

  getLocalStorageToken = async token => {
    try {
      const item = token || localStorage.getItem(LOCAL_STORAGE_KEY)
      if (item) {
        const verify = await this.jwt.verify(item, process.env.REACT_APP_JSON_TOKEN)
        if (verify) {
           return verify
        }
        return null
      }
    } catch (err) {
      throw err
    }
  }

  getToken = () => {
    try {
      const item = localStorage.getItem(LOCAL_STORAGE_KEY)
      if (item) {
        const verify = this.jwt.verify(item, process.env.REACT_APP_JSON_TOKEN)
        if (verify) {
           return verify
        }
        return null
      }
    } catch (err) {
      return null
    }
  }

  removeToken = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEY)
  }

  getFavoriteList = () => {
    try {
      const favorites = localStorage.getItem(FAVORITE_LIST)
      if (!favorites) return []
      return JSON.parse(favorites)['favorites']
    } catch (err) {
      return null
    }
  }

  getFavoriteListOnlyMaterials = () => {
    try {
      const favorites = localStorage.getItem(FAVORITE_LIST)
      
      if (!favorites) return []

      let favoriteList = JSON.parse(favorites)['favorites']

      const allMaterials = favoriteList.map(item => item.materials)

      const materials = allMaterials.reduce((cur, prev) => cur.concat(prev), [])

      return materials.length > 0 ? materials : []
    } catch (err) {
      return null
    }
  }

  addFavoriteItem = ({ item }) => {
    try {

      let favorites = localStorage.getItem(FAVORITE_LIST)

      favorites = (favorites) ? JSON.parse(favorites)['favorites'] : [];

      let typeFound = favorites.find(({ name }) => name === item.type)

      if (!typeFound) {
        favorites.push({ name: item.type, materials: [], hasMore: false })
        typeFound = favorites.find(({ name }) => name === item.type)
      }

      const material = typeFound.materials.find(({ name }) => name === item.name)
      
      if (!material) typeFound.materials.push({ 
        ...item,
        isFavorite: true
      })

      localStorage.setItem(FAVORITE_LIST, JSON.stringify({ favorites }))

    } catch (err) {
      return null
    }
  }

  removeFavoriteITem = ({ item }) => {
    try {

      let favorites = localStorage.getItem(FAVORITE_LIST)

      favorites = (favorites) ? JSON.parse(favorites)['favorites'] : [];

      let typeFound = favorites.find(({ name }) => name === item.type)

      if (typeFound) {
        typeFound = favorites.find(({ name }) => name === item.type)
      }

      const material = typeFound.materials.find(({ name }) => name === item.name)

      if (material) {
        typeFound.materials = typeFound.materials.filter(({ name }) => name !== item.name)
        favorites = favorites.map(( list ) => {
          if (list.name === item.name) {
            return typeFound
          }
          return list
        })
      }

      localStorage.setItem(FAVORITE_LIST, JSON.stringify({ favorites }))

    } catch (err) {
      return null
    }
  }
}

export default LocalStorageService